if (!customElements.get("sub-widget")) {
  customElements.define(
    "sub-widget",
    class SubWidget extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.init();
      }

      init() {
        this.handlePlanClick = this.handlePlanClick.bind(this);

        this.isLpFlow = this.closest("[data-lp-purchase-mode]") !== null;

        this.sellingPlanInput = this.querySelector("input[type='hidden']");
        this.allPlans = this.querySelectorAll(".wt-subscription-widget__plans");

        this.addEventListeners();
        this.addOptionCardListeners();
        this.addDurationSwitchListeners();
        this.setInitialPlan();
      }

      setInitialPlan() {
        if (this.isLpFlow) {
          this.initLpState();
          return;
        }
        const initialPlanSelected = this.querySelector('.wt-subscription-widget__plans--selected');
        if (initialPlanSelected) {
          this.handlePlanClick(initialPlanSelected);
        }
      }

      reinit() {
        this.sellingPlanInput = this.querySelector("input[type='hidden']");
        this.allPlans = this.querySelectorAll(".wt-subscription-widget__plans");
        this.allPlans.forEach((plan) => {
          plan.addEventListener("click", () => this.handlePlanClick(plan));
        });

        this.addSelectListeners();
        this.addOptionCardListeners();
        this.addDurationSwitchListeners();
        this.setInitialPlan();
      }

      addEventListeners() {
        this.allPlans.forEach((plan) => {
          plan.addEventListener("click", () => this.handlePlanClick(plan));
        });

        this.addSelectListeners();
        this.addLpBuyOnceListeners();

        this.unsubscribeVariantChange = subscribe(PUB_SUB_EVENTS.variantChange, (e) => {
          const wrapper = this.closest('[data-section-id]');
          const sectionId = wrapper?.dataset?.sectionId;
          const originalSectionId = wrapper?.dataset?.originalSectionId;
          if (sectionId && e.data.sectionId !== sectionId && e.data.sectionId !== originalSectionId) return;

          const parsedHTML = e.data.html.querySelector(".wt-subscription-widget__container");
          if (!parsedHTML) return;

          const currentContainer = this.querySelector('.wt-subscription-widget__container');
          if (!currentContainer) return;

          currentContainer.innerHTML = parsedHTML.innerHTML;
          this.reinit();

          if (originalSectionId) {
            const hiddenInput = this.querySelector('input[name="selling_plan"]');
            if (hiddenInput) hiddenInput.setAttribute('form', `product-form-${sectionId}`);
          }

          if (!this.isLpFlow && this._pendingDurationSwitch) {
            const pending = this._pendingDurationSwitch;
            this._pendingDurationSwitch = null;
            if (this.sellingPlanInput) {
              this.sellingPlanInput.value = pending.sellingPlanId || "";
            }
            const selectedPlan = this.querySelector(".wt-subscription-widget__plans--selected");
            if (selectedPlan) {
              this.applyDurationCardData(selectedPlan, pending);
            }
          }
        });
      }

      addSelectListeners() {
        this.querySelectorAll(".wt-subscription-widget__plan-content__select").forEach((select) => {
          select.addEventListener("change", (e) => {
            e.stopPropagation();
            this.handleSelectChange(select);
          });
        });
      }

      addOptionCardListeners() {
        this.querySelectorAll("[data-option-cards]").forEach((cardGroup) => {
          if (cardGroup.dataset.cardsInitialized === "true") return;
          cardGroup.dataset.cardsInitialized = "true";

          const select = cardGroup.closest(".wt-subscription-widget__plans")?.querySelector(
            ".wt-subscription-widget__plan-content__select"
          );

          cardGroup.querySelectorAll(".wt-subscription-widget__option-card").forEach((card) => {
            card.addEventListener("click", (event) => {
              if (this.isLpFlow && card.dataset.durationValue) {
                event.stopPropagation();
                this.selectLpCard(card);
                return;
              }

              cardGroup.querySelectorAll(".wt-subscription-widget__option-card").forEach((c) => {
                c.classList.remove("wt-subscription-widget__option-card--selected");
                c.setAttribute("aria-checked", "false");
              });
              card.classList.add("wt-subscription-widget__option-card--selected");
              card.setAttribute("aria-checked", "true");

              if (card.dataset.durationValue) {
               
                event.stopPropagation();

                const cardData = {
                  sellingPlanId: card.dataset.sellingPlanId || "",
                  price: card.dataset.price,
                  compareAtPrice: card.dataset.compareAtPrice,
                  priceFormatted: card.dataset.priceFormatted,
                  compareAtPriceFormatted: card.dataset.compareAtPriceFormatted,
                  priceRaw: card.dataset.priceRaw,
                  compareAtPriceRaw: card.dataset.compareAtPriceRaw,
                  perDayPrice: card.dataset.perDayPrice,
                };

                const plan = cardGroup.closest(".wt-subscription-widget__plans");
                if (plan) {
                  this.allPlans.forEach((item) => item.classList.remove("wt-subscription-widget__plans--selected"));
                  plan.classList.add("wt-subscription-widget__plans--selected");

                  if (this.sellingPlanInput) this.sellingPlanInput.value = cardData.sellingPlanId;
                  this.applyDurationCardData(plan, cardData);
                }

                this._pendingDurationSwitch = cardData;

                this.clickNativeVariantOption(cardGroup.dataset.durationOptionName, card.dataset.durationValue);
                return;
              }

              if (select) {
                select.value = card.dataset.optionValue;
              
              }
            });
          });
        });
      }

      
      addDurationSwitchListeners() {
        if (this.isLpFlow) return;

        this.querySelectorAll("[data-duration-value]").forEach((el) => {
          if (el.dataset.durationSwitchInitialized === "true") return;
          el.dataset.durationSwitchInitialized = "true";

          if (el.classList.contains("wt-subscription-widget__option-card")) return;

          el.addEventListener("click", () => {
            this.clickNativeVariantOption(el.dataset.durationOptionName, el.dataset.durationValue);
          });
        });
      }

     
      clickNativeVariantOption(optionName, value) {
        if (!optionName || !value) return;
        const root = this.closest('section') || document;
        const input = root.querySelector(
          `input[name="${CSS.escape(optionName)}"][value="${CSS.escape(value)}"]`
        );
        if (input && !input.checked) {
          input.click();
        }
      }

      
      applyDurationCardData(plan, data) {
        this.updatePrice(plan, data.compareAtPrice, data.price);

        const currentEl = plan.querySelector(".wt-subscription-widget__price-current");
        if (currentEl && data.price) currentEl.textContent = data.price;

        const compareEl = plan.querySelector(".wt-subscription-widget__price-compare");
        if (compareEl) {
          const hasCompare = data.compareAtPrice && data.compareAtPrice !== data.price;
          compareEl.hidden = !hasCompare;
          if (hasCompare) compareEl.textContent = data.compareAtPrice;
        }

        const perDayEl = plan.querySelector(".wt-subscription-widget__price-row__right");
        if (perDayEl && data.perDayPrice) {
          perDayEl.textContent = data.perDayPrice + " per day";
        }

        const badgeEl = plan.querySelector(".wt-subscription-widget__badge");
        if (badgeEl) {
          const priceRawNum = Number(data.priceRaw);
          const compareRawNum = Number(data.compareAtPriceRaw);
          if (compareRawNum > priceRawNum && compareRawNum > 0) {
            const percent = Math.round(((compareRawNum - priceRawNum) / compareRawNum) * 100);
            if (/\d+%/.test(badgeEl.textContent)) {
              badgeEl.textContent = badgeEl.textContent.replace(/\d+%/, `${percent}%`);
            } else {
              badgeEl.textContent = `${percent}%`;
            }
            badgeEl.hidden = false;
          } else {
            badgeEl.hidden = true;
          }
        }

        const priceData = {
          price: data.priceFormatted,
          compareAtPrice: data.compareAtPriceFormatted,
          priceRaw: Number(data.priceRaw),
          compareAtPriceRaw: Number(data.compareAtPriceRaw),
        };
        this.updatePriceBlock(priceData);
        this.updateStickyPriceBlock(priceData);
      }

      handleSelectChange(select) {
        const plan = select.closest(".wt-subscription-widget__plans");
        if (!plan || !plan.classList.contains("wt-subscription-widget__plans--selected")) return;

        const selectedOption = select.options[select.selectedIndex];
        if (!selectedOption) return;

        this.sellingPlanInput.value = selectedOption.value;

        const compareAtPrice = selectedOption.dataset.compareAtPrice;
        const price = selectedOption.dataset.price;
        this.updatePrice(plan, compareAtPrice, price);
        this.updateURLParamsIfEnabled(selectedOption.value);
        const priceData = {
          price: selectedOption.dataset.priceFormatted,
          compareAtPrice: selectedOption.dataset.compareAtPriceFormatted,
          priceRaw: Number(selectedOption.dataset.priceRaw),
          compareAtPriceRaw: Number(selectedOption.dataset.compareAtPriceRaw),
        };
        this.updatePriceBlock(priceData);
        this.updateStickyPriceBlock(priceData);
      }

      handlePlanClick(plan) {
        if (this.isLpFlow) {
          this.handleLpPlanClick(plan);
          return;
        }

        this.allPlans.forEach((item) => {
          item.classList.remove("wt-subscription-widget__plans--selected");
        });
        plan.classList.add("wt-subscription-widget__plans--selected");

        const selectedPlanValue = plan.querySelector("select")?.value;
        if (selectedPlanValue) {
          this.sellingPlanInput.value = selectedPlanValue;
          const selectedOption = [...plan.querySelector("select").options].find(
            (option) => option.value === selectedPlanValue
          );
          if (selectedOption) {
            const compareAtPrice = selectedOption.dataset.compareAtPrice;
            const price = selectedOption.dataset.price;
            this.updatePrice(plan, compareAtPrice, price);
            const priceData = {
              price: selectedOption.dataset.priceFormatted,
              compareAtPrice: selectedOption.dataset.compareAtPriceFormatted,
              priceRaw: Number(selectedOption.dataset.priceRaw),
              compareAtPriceRaw: Number(selectedOption.dataset.compareAtPriceRaw),
            };
            this.updatePriceBlock(priceData);
            this.updateStickyPriceBlock(priceData);
          }
        } else {
          this.sellingPlanInput.value = "";
          const priceData = {
            price: plan.dataset.priceFormatted,
            compareAtPrice: plan.dataset.compareAtPriceFormatted,
            priceRaw: Number(plan.dataset.priceRaw),
            compareAtPriceRaw: Number(plan.dataset.compareAtPriceRaw),
          };
          this.updatePriceBlock(priceData);
          this.updateStickyPriceBlock(priceData);
        }

        this.updateURLParamsIfEnabled(selectedPlanValue);
      }

      updatePrice(plan, compareAtPrice, price) {
        if (plan.id === 'single-purchase-plan' && plan.querySelector('[data-buyonce-total]')) return;
        const priceElement = plan.querySelector('.wt-subscription-widget__plan-header__price-regular');
        const compareAtPriceElement = plan.querySelector('.wt-subscription-widget__plan-header__price-sale');

        if (compareAtPrice && compareAtPriceElement) {
          compareAtPriceElement.innerHTML = compareAtPrice;
        }
        if (priceElement) {
          if (compareAtPrice) {
            priceElement.classList.add('wt-subscription-widget__plan-header__price-regular--sale');
          } else {
            priceElement.classList.remove('wt-subscription-widget__plan-header__price-regular--sale');
          }
          if (price) {
            priceElement.innerHTML = price;
          }
        }
      }

      updatePriceBlock({ price, compareAtPrice, priceRaw, compareAtPriceRaw }) {
        const sectionId = this.closest('[data-section-id]')?.dataset?.sectionId;
        if (!sectionId) return;

        const priceBlock = document.getElementById(`price-${sectionId}`);
        if (!priceBlock) return;

        const priceContainer = priceBlock.querySelector('.price');
        if (!priceContainer) return;

        const isOnSale = compareAtPriceRaw > priceRaw;

        priceContainer.classList.toggle('price--on-sale', isOnSale);

        const regularPriceEl = priceContainer.querySelector('.price__regular .wt-product__price__final');
        if (regularPriceEl) regularPriceEl.innerHTML = price;

        const salePriceEl = priceContainer.querySelector('.price__sale .wt-product__price__final');
        if (salePriceEl) salePriceEl.innerHTML = price;

        const saleDiv = priceContainer.querySelector('.price__sale');
        if (saleDiv) {
          saleDiv.classList.toggle('visible', isOnSale);
          saleDiv.classList.remove('visible-main-product');
        }

        const compareEl = priceContainer.querySelector('.wt-product__price__compare');
        if (compareEl) {
          compareEl.innerHTML = isOnSale ? compareAtPrice : '';
          compareEl.classList.toggle('hidden', !isOnSale);
        }

        let percentEl = priceContainer.querySelector('.price-item--percent');
        if (isOnSale) {
          const percent = Math.round((compareAtPriceRaw - priceRaw) / compareAtPriceRaw * 100);
          if (percentEl) {
            percentEl.textContent = `-${percent}%`;
          } else {
            const wrapper = priceContainer.querySelector('.price__sale__details-wrapper');
            if (wrapper) {
              percentEl = document.createElement('span');
              percentEl.className = 'price-item--percent';
              percentEl.textContent = `-${percent}%`;
              wrapper.appendChild(percentEl);
            }
          }
        } else if (percentEl) {
          percentEl.remove();
        }
      }

      updateStickyPriceBlock({ price, compareAtPrice, priceRaw, compareAtPriceRaw }) {
        const sectionId = this.closest('[data-section-id]')?.dataset?.sectionId;
        if (!sectionId) return;

        const stickyPriceBlock = document.getElementById(`sticky-price-${sectionId}`);
        if (!stickyPriceBlock) return;

        const priceContainer = stickyPriceBlock.querySelector('.price');
        if (!priceContainer) return;

        const isOnSale = compareAtPriceRaw > priceRaw;

        priceContainer.classList.toggle('price--on-sale', isOnSale);

        const regularPriceEl = priceContainer.querySelector('.price__regular .wt-product__price__final');
        if (regularPriceEl) regularPriceEl.innerHTML = price;

        const salePriceEl = priceContainer.querySelector('.price__sale .wt-product__price__final');
        if (salePriceEl) salePriceEl.innerHTML = price;

        const saleDiv = priceContainer.querySelector('.price__sale');
        if (saleDiv) {
          saleDiv.classList.toggle('visible', isOnSale);
          saleDiv.classList.remove('visible-main-product');
        }

        const compareEl = priceContainer.querySelector('.wt-product__price__compare');
        if (compareEl) {
          compareEl.innerHTML = isOnSale ? compareAtPrice : '';
          compareEl.classList.toggle('hidden', !isOnSale);
        }

        let percentEl = priceContainer.querySelector('.price-item--percent');
        if (isOnSale) {
          const percent = Math.round((compareAtPriceRaw - priceRaw) / compareAtPriceRaw * 100);
          if (percentEl) {
            percentEl.textContent = `-${percent}%`;
          } else {
            const wrapper = priceContainer.querySelector('.price__sale__details-wrapper');
            if (wrapper) {
              percentEl = document.createElement('span');
              percentEl.className = 'price-item--percent';
              percentEl.textContent = `-${percent}%`;
              wrapper.appendChild(percentEl);
            }
          }
        } else if (percentEl) {
          percentEl.remove();
        }
      }

      updateURLParamsIfEnabled(planId) {
        const wrapper = this.closest('[data-update-url-on-plan-change]');
        if (wrapper?.dataset.updateUrlOnPlanChange === 'false') return;

        const urlParams = new URLSearchParams(window.location.search);
        if (planId) {
          urlParams.set("selling_plan", planId);
        } else {
          urlParams.delete("selling_plan");
        }
        window.history.pushState({}, "", `${window.location.pathname}?${urlParams.toString()}`);
      }

      getLpSubscribePlan() {
        return this.querySelector(".wt-subscription-widget__plans--subscribe");
      }

      getLpOneTimePlan() {
        return this.querySelector("#single-purchase-plan");
      }

      getLpCards() {
        return Array.from(
          this.querySelectorAll(".wt-subscription-widget__option-card[data-duration-value]")
        );
      }

      getLpForm() {
        const formId =
          this.querySelector("input[name='selling_plan']")?.getAttribute("form") ||
          `product-form-${this.closest("[data-section-id]")?.dataset?.sectionId}`;
        return document.getElementById(formId);
      }

      getLpDurationOptionName() {
        return this.querySelector("[data-duration-option-name]")?.dataset.durationOptionName || "";
      }

      getLpServing() {
        const optionName = this.getLpDurationOptionName();
        if (!optionName) return "";
        const root = this.closest("section") || document;
        return root.querySelector(`input[name="${CSS.escape(optionName)}"]:checked`)?.value || "";
      }

      selectLpServing(value) {
        this.clickNativeVariantOption(this.getLpDurationOptionName(), value);
      }

      getLpCurrentCard() {
        const serving = this.getLpServing();
        return this.getLpCards().find((card) => card.dataset.durationValue === serving) || null;
      }

      getLpBuyOnceServing() {
        return this.closest("[data-lp-buy-once-serving]")?.dataset.lpBuyOnceServing || "";
      }

      enforceLpBuyOnceServing() {
        if (this.hasLpBuyOnceRows()) return;
        const buyOnce = this.getLpBuyOnceServing();
        if (!buyOnce || this.getLpEffectiveMode() !== "once") return;
        if (this.getLpServing() !== buyOnce) this.selectLpServing(buyOnce);
      }

      getLpEffectiveMode() {
        const subscribePlan = this.getLpSubscribePlan();
        const subscribeDisabled =
          !subscribePlan ||
          subscribePlan.classList.contains("wt-subscription-widget__plans--disabled");
        if (this._lpMode === "subscribe" && subscribeDisabled) return "once";
        return this._lpMode || "subscribe";
      }

      initLpState() {
        if (!this._lpMode) {
          const selectedPlan = this.querySelector(".wt-subscription-widget__plans--selected");
          this._lpMode =
            selectedPlan && selectedPlan === this.getLpOneTimePlan() ? "once" : "subscribe";
        }

        if (this.getLpEffectiveMode() === "subscribe" && this.getLpServing() && !this.getLpCurrentCard()) {
          const previous = this.getLpCards().find(
            (card) => !card.disabled && card.dataset.durationValue === this._lpSubServing
          );
          if (previous) this.selectLpServing(previous.dataset.durationValue);
          else this._lpMode = "once";
        }

        this.enforceLpBuyOnceServing();
        this.applyLpState();
      }

      applyLpState() {
        const mode = this.getLpEffectiveMode();
        const serving = this.getLpServing();

        this.querySelectorAll(".wt-subscription-widget__plans").forEach((plan) => {
          plan.classList.remove("wt-subscription-widget__plans--selected");
        });
        const activePlan = mode === "once" ? this.getLpOneTimePlan() : this.getLpSubscribePlan();
        activePlan?.classList.add("wt-subscription-widget__plans--selected");

        this.getLpCards().forEach((card) => {
          if (serving) {
            const selected = card.dataset.durationValue === serving;
            card.classList.toggle("wt-subscription-widget__option-card--selected", selected);
            card.setAttribute("aria-checked", String(selected));
          }
          if (mode === "once" && this.getLpBuyOnceServing()) {
            card.setAttribute("aria-disabled", "true");
          } else {
            card.removeAttribute("aria-disabled");
          }
        });

        if (mode === "subscribe" && this.getLpCurrentCard()) this._lpSubServing = serving;

        this.setAttribute("data-purchase-mode", mode);
        this.syncLpSellingPlan();
        this.bindLpFormGuard();
        this.bindLpBuyOnceSubmit();
        if (mode === "subscribe") this._lpBuyOnceUnits = 1;
        this.renderLpBuyOnce();
        this.syncLpBuyOnceButton();
      }

      handleLpPlanClick(plan) {
        const isOnce = plan.id === "single-purchase-plan";
        if (!isOnce && plan.classList.contains("wt-subscription-widget__plans--disabled")) return;

        this._lpMode = isOnce ? "once" : "subscribe";

        if (isOnce) {
          this.enforceLpBuyOnceServing();
        } else if (!this.getLpCurrentCard()) {
          const cards = this.getLpCards().filter((card) => !card.disabled);
          const target =
            cards.find((card) => card.dataset.durationValue === this._lpSubServing) || cards[0];
          if (target) this.selectLpServing(target.dataset.durationValue);
        }
        this.applyLpState();
      }

      selectLpCard(card) {
        const cardGroup = card.closest("[data-option-cards]");
        if (!cardGroup) return;

        const plan = cardGroup.closest(".wt-subscription-widget__plans");

        if (plan) {
          this.allPlans.forEach((item) => {
            item.classList.remove("wt-subscription-widget__plans--selected");
          });

          plan.classList.add("wt-subscription-widget__plans--selected");

          this.applyDurationCardData(plan, {
            sellingPlanId: card.dataset.sellingPlanId || "",
            price: card.dataset.price,
            compareAtPrice: card.dataset.compareAtPrice,
            priceFormatted: card.dataset.priceFormatted,
            compareAtPriceFormatted: card.dataset.compareAtPriceFormatted,
            priceRaw: card.dataset.priceRaw,
            compareAtPriceRaw: card.dataset.compareAtPriceRaw,
            perDayPrice: card.dataset.perDayPrice,
          });
        }

        this._lpMode = "subscribe";
        this._lpSubServing = card.dataset.durationValue;

        this.selectLpServing(card.dataset.durationValue);

        this.applyLpState();
      }
      syncLpSellingPlan() {
        const input = this.querySelector("input[name='selling_plan']");
        if (!input) return "";
        this.sellingPlanInput = input;

        let value = "";
        if (this.getLpEffectiveMode() === "subscribe") {
          value = this.getLpCurrentCard()?.dataset.sellingPlanId || "";
        }
        input.value = value;

        const urlPlan = new URLSearchParams(window.location.search).get("selling_plan") || "";
        if (urlPlan !== value) this.updateURLParamsIfEnabled(value);

        return value;
      }

      getPurchaseState() {
        if (this.isLpFlow) {
          const sellingPlanId = this.syncLpSellingPlan();
          const mode = this.getLpEffectiveMode();

          if (mode === "once" && this.hasLpBuyOnceRows()) {
            const items = this.getLpBuyOnceItems();
            return {
              mode,
              sellingPlanId: "",
              items,
              error: items.length ? "" : "Please select at least one flavor.",
            };
          }

          const buyOnce = this.getLpBuyOnceServing();
          const serving = this.getLpServing();
          let error = "";
          if (mode === "subscribe" && !sellingPlanId) {
            error = "Please select a subscription plan to continue.";
          } else if (mode === "once" && buyOnce && serving && serving !== buyOnce) {
            error = `Buy Once is only available for ${buyOnce}.`;
          }
          return { mode, sellingPlanId, error };
        }
        const sellingPlanId = this.sellingPlanInput?.value || "";
        return { mode: sellingPlanId ? "subscribe" : "once", sellingPlanId, error: "" };
      }

      bindLpFormGuard() {
        const form = this.getLpForm();
        if (!form || form.dataset.lpPurchaseGuard === "true") return;
        form.dataset.lpPurchaseGuard = "true";

        form.addEventListener(
          "submit",
          (event) => {
            const state = this.getPurchaseState();
            if (state.error) {
              event.preventDefault();
              event.stopImmediatePropagation();
              const productForm = form.closest("product-form");
              if (productForm && typeof productForm.handleErrorMessage === "function") {
                productForm.handleErrorMessage(state.error);
              }
            }
          },
          true
        );
      }

      hasLpBuyOnceRows() {
        return this.querySelector("[data-buyonce-panel] [data-variant-id]") !== null;
      }

      getLpBuyOnceUnits() {
        return this._lpBuyOnceUnits || 1;
      }

      setLpBuyOnceUnits(units) {
        this._lpBuyOnceUnits = Math.max(1, Math.min(999, parseInt(units, 10) || 0));
        this.renderLpBuyOnce();
        this.syncLpBuyOnceButton();
      }

      isLpVarietyRow(row) {
        return /variety/i.test(row.dataset.flavor || "");
      }

      getLpBuyOnceSelection() {
        const rows = Array.from(this.querySelectorAll("[data-buyonce-panel] [data-variant-id]"));
        const root = this.closest("section") || document;
        const selected = Array.from(root.querySelectorAll('input[type="radio"]:checked')).map((input) => input.value);
        const flavorRow = rows.find((row) => row.dataset.flavor && selected.includes(row.dataset.flavor));
        if (flavorRow && !this.isLpVarietyRow(flavorRow)) {
          const boxes = parseInt(this.closest("[data-lp-buy-once-serving]")?.dataset.lpBuyOnceBoxes, 10) || 1;
          return { rows: [flavorRow], boxes };
        }
        // Variety Pack (or no single flavor selected): one of each individual
        // flavor per pack -- never the Variety Pack variant itself.
        const individualRows = rows.filter((row) => !this.isLpVarietyRow(row));
        return { rows: individualRows.length ? individualRows : rows, boxes: 1 };
      }

      getLpBuyOnceRows() {
        return this.getLpBuyOnceSelection().rows;
      }

      getLpBuyOnceTotalCents() {
        const { rows, boxes } = this.getLpBuyOnceSelection();
        const units = this.getLpBuyOnceUnits();
        return rows.reduce((sum, row) => sum + units * boxes * (parseInt(row.dataset.price, 10) || 0), 0);
      }

      getLpBuyOnceItems() {
        const { rows, boxes } = this.getLpBuyOnceSelection();
        if (rows.some((row) => row.classList.contains("is-unavailable"))) return [];
        const quantity = this.getLpBuyOnceUnits() * boxes;
        return rows.map((row) => ({ id: Number(row.dataset.variantId), quantity }));
      }

      formatLpMoney(cents) {
        const formatted =
          window.Shopify && typeof window.Shopify.formatMoney === "function"
            ? window.Shopify.formatMoney(cents)
            : "$" + (cents / 100).toFixed(2);
        return formatted.replace(/[.,]00(?!\d)/, "");
      }
      renderLpBuyOnce() {
        const plan = this.getLpOneTimePlan();
        if (!plan || !this.hasLpBuyOnceRows()) return;

        const units = this.getLpBuyOnceUnits();
        const input = plan.querySelector("[data-buyonce-input]");
        if (input && input.value !== String(units)) input.value = String(units);
        const decrease = plan.querySelector("[data-buyonce-decrease]");
        if (decrease) decrease.disabled = units <= 1;

        const totalCents = this.getLpBuyOnceTotalCents();
        const totalEl = plan.querySelector("[data-buyonce-total]");
        if (totalEl && totalCents > 0) totalEl.textContent = this.formatLpMoney(totalCents);
      }
      syncLpBuyOnceButton() {
        const sectionId = this.closest("[data-section-id]")?.dataset?.sectionId;
        const button = sectionId && document.getElementById(`ProductSubmitButton-${sectionId}`);
        const label = button && button.querySelector(":scope > span");
        if (!button || !label) return;

        const inOnce = this.getLpEffectiveMode() === "once" && this.hasLpBuyOnceRows();
        const setLabel = (text) => {
          if (text) label.textContent = text;
        };
        const addLabel = () => {
          const custom = button.getAttribute("data-custom-add-label");
          if (custom) label.innerHTML = custom;
          else setLabel(window.variantStrings?.addToCart);
        };

        if (inOnce) {
          const anyAvailable = !!this.querySelector(
            "[data-buyonce-panel] [data-variant-id]:not(.is-unavailable)"
          );
          button.dataset.lpBuyOnceOverride = "true";
          if (anyAvailable) {
            if (this.getLpBuyOnceItems().length > 0) button.removeAttribute("disabled");
            else button.setAttribute("disabled", "disabled");
            addLabel();
          } else {
            button.setAttribute("disabled", "disabled");
            setLabel(window.variantStrings?.soldOut);
          }
        } else if (button.dataset.lpBuyOnceOverride === "true") {
          delete button.dataset.lpBuyOnceOverride;
          const variant = document.querySelector(`variant-options[data-section="${sectionId}"]`)?.currentVariant;
          if (variant && variant.available) {
            button.removeAttribute("disabled");
            addLabel();
          } else {
            button.setAttribute("disabled", "disabled");
            setLabel(window.variantStrings?.soldOut);
          }
        }
      }

      addLpBuyOnceListeners() {
        if (!this.isLpFlow) return;

        this.addEventListener(
          "click",
          (event) => {
            const panel = event.target.closest("[data-buyonce-panel]");
            if (!panel) return;
            event.stopPropagation();

            const button = event.target.closest("[data-buyonce-increase], [data-buyonce-decrease]");
            if (!button || button.disabled) return;
            const delta = button.hasAttribute("data-buyonce-increase") ? 1 : -1;
            this.setLpBuyOnceUnits(this.getLpBuyOnceUnits() + delta);
          },
          true
        );

        this.addEventListener(
          "change",
          (event) => {
            const input = event.target.closest("[data-buyonce-input]");
            if (!input) return;
            event.stopPropagation();
            this.setLpBuyOnceUnits(input.value);
          },
          true
        );
      }

      bindLpBuyOnceSubmit() {
        const sectionId = this.closest("[data-section-id]")?.dataset?.sectionId;
        const button = sectionId && document.getElementById(`ProductSubmitButton-${sectionId}`);
        if (!button || button.dataset.lpBuyOnceBound === "true") return;
        button.dataset.lpBuyOnceBound = "true";

        button.addEventListener(
          "click",
          (event) => {
            if (this.getLpEffectiveMode() !== "once" || !this.hasLpBuyOnceRows()) return;
            if (button.getAttribute("aria-disabled") === "true") return;
            if (document.querySelector(`[data-routine-popup][data-main-section-id="${sectionId}"]`)) return;

            event.preventDefault();
            event.stopImmediatePropagation();
            this.addLpBuyOnceToCart(button);
          },
          true
        );
      }

      addLpBuyOnceToCart(button) {
        const productForm = button.closest("product-form");
        const showError = (message) => {
          if (productForm && typeof productForm.handleErrorMessage === "function") {
            productForm.handleErrorMessage(message || false);
          }
        };

        showError(false);
        const state = this.getPurchaseState();
        if (state.error) {
          showError(state.error);
          return;
        }

        const cart = document.querySelector("cart-drawer");
        const body = { items: state.items, sections_url: window.location.pathname };
        if (cart && typeof cart.getSectionsToRender === "function") {
          body.sections = cart.getSectionsToRender().map((section) => section.id).join(",");
        }

        const config = fetchConfig("json");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        config.body = JSON.stringify(body);

        button.setAttribute("aria-disabled", "true");
        button.classList.add("loading");

        fetch(window.routes.cart_add_url, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: "product-form",
                errors: response.errors || response.description,
                message: response.message,
              });
              showError(response.description || response.message || "Something went wrong. Please try again.");
              return;
            }

            publish(PUB_SUB_EVENTS.cartUpdate, { source: "product-form", cartData: response });

            if (!cart || typeof cart.renderContents !== "function") {
              window.location = window.routes.cart_url;
              return;
            }
            const refresh = () => document.dispatchEvent(new CustomEvent("cart-drawer:refresh", { bubbles: true }));
            try {
              const isClosedCart = !document.body.classList.contains("page-overlay-cart-on");
              const rendered = cart.renderContents(response, isClosedCart);
              if (rendered && typeof rendered.catch === "function") rendered.catch(refresh);
            } catch (error) {
              refresh();
            }
          })
          .catch((error) => {
            console.error("[subscription-widget] Buy Once add to cart failed:", error);
            showError("Something went wrong. Please try again.");
          })
          .finally(() => {
            button.removeAttribute("aria-disabled");
            button.classList.remove("loading");
          });
      }

      disconnectedCallback() {
        if (typeof this.unsubscribeVariantChange === 'function') {
          this.unsubscribeVariantChange();
        }
      }
    }
  );
}
